import React from 'react';
import { useSelector } from "react-redux";

const AboutImage = () => {
    var imageView = useSelector(state => state.image);
    var imageText = useSelector(state => state.aboutImageText);
    return ( 
        <div>
            <img style={{width:'100%',height:'50%'}} src={imageView} />
<p>{imageText}</p>

        </div>
     );
}
 
export default AboutImage;